<template>
  <div style="height:100%">
    <b-tabs v-model="tab_index" ref="MyTabs" active-nav-item-class="font-weight-bold text-uppercase text-danger"
      active-tab-class="" content-class="" size="sm">
      <b-tab title="so.sales_order" active activate-tab="active_tab">
        <SplitContainer3 style="height:100%" :layout="12">
          <!-- <SplitContainer3 :style="{ height: MyHeight + 'px' }" :layout="12"> -->

          <template #main>
            <TableMain name="myName" ref="TestTable" :fields="get_fields('data/s/atest', 'so')"
              :detail_tables_setting="detail_tables_setting" :show_date_picker="true" :show_toolbar="true"
              :show_filter="true" :selectable="true" :title="table_title.title1" @on_query="on_query"
              @on_change="on_change" @on_cell_button_click="on_cell_button_click" @on_input="on_input"
              @state_change="state_change" @tool_invoke="tool_invoke" @current_changed="current_changed">
              <template #query>
                <TestQueryPanel>
                  <template v-slot:QueryCondition>
                    <div>hi query condition</div>
                  </template>
                </TestQueryPanel>
              </template>
              <!-- <template #state_change="selected_items">
                <b-dropdown-item
                  @click="state_change_slot('valid', selected_items)"
                  >test state slot</b-dropdown-item
                >
              </template> -->
              <template #toolbar>
                <b-button size="sm" class="ml-2">tool bar</b-button>
              </template>
              <template #operation>
                <div style="text-align: right; padding: 2px">
                  <b-button size="sm">operation</b-button>
                </div>
              </template>
            </TableMain>
          </template>
          <template #top>
            <TableMain :show_query_container="false" ref="TestTable1" :table_height_adjust="-6"
              :title="table_title.title2">
            </TableMain>
          </template>
          <template #bottom>
            <TableMain :show_query_container="false" :table_height_adjust="-12" :page_sizes="null" name="test"
              ref="TestTableExt" :title="table_title.title3" :fields="get_fields('data/s/atest', 'test')"
              :detail_tables_setting="detail_tables_setting">
              <template #toolbar="">
                <el-button>s++</el-button>
              </template>
            </TableMain>
          </template>
        </SplitContainer3>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
// import axios from "axios"
// -- import * as _ from "lodash-es"
import * as api from "../shared/api"
import QueryButton from "./components/base/QueryButton"
import TableMain from "./components/table/TableMain"
import TableDetail from "./components/table/TableDetail"
import TestQueryPanel from "./components/base/TestQueryPanel"
import BaseContainer from "./components/BaseContainer"
import EntityEditor from "./components/base/EntityEditor"
import SplitContainer3 from "./components/container/SplitContainer3"
import SplitContainer2 from "./components/container/SplitContainer2"
// import TestData from "../model/Test";
// import * as biz_data_helper from "../shared/biz_data_helper";
import { Split } from "view-design"
import "view-design/dist/styles/iview.css"
import { parse, format, isValid } from "date-fns"
import { Database } from "../store/db"
import md5 from "blueimp-md5"
import * as tools from "../shared/tools"
import TestHelper from "../controllers/test/TestHelper"

export default {
  components: {
    QueryButton,
    TableDetail,
    TableMain,
    TestQueryPanel,
    BaseContainer,
    EntityEditor,
    Split,
    SplitContainer3,
    SplitContainer2,
  },
  data() {
    return {
      table_title: {
        title1: "so.sales_order_list",
        title2: "so.valid_product_list",
        title3: "so.sales_order_item_list",
      },
      biz_data: {
        test_data_list: [],
        test_data_object: {},
      },
      // items: this.$store.state.biz_data.test_data.orders,
      data: [
        {
          echo: "",
          name: "name",
          text: "大肆砍伐發射點犯得上開了房間dksjfk4375493759348了解",
          num: 100,
          test_date: "2020-01-20",
          extra: [],
        },
      ],
      // fields:["echo","show_details"] ,
      detail_tables_setting: {
        echo: {
          _endpoint_code: "data/s/atest",
          _content_type: "test",
          _value_field: "echo",
          _parameter_name: "c",
          _fields: {
            echo: { route_link_to: "Home" },
          },
        },
        n: {
          _endpoint_code: "data/s/atest",
          _content_type: "test",
          _value_field: "n",
          _parameter_name: "c",
          echo: {
            _endpoint_code: "data/s/atest",
            _content_type: "test",
            _value_field: "echo",
            _parameter_name: "c",
          },
        },
      },
      provider: this.$store.state.cars.provider,
      // selected: [],
      // selectMode: "multi",
      // table_height: "200px",
      locale: this.$i18n.locale,
      searchBy: "asdfsad",
      split_setting1: 0.5,
      split_setting2: 0.5,
      tab_index: 1,
    }
  },
  activated() { },
  deactivated() { },
  computed: {
    MyHeight() {
      return this.$root.main_content_height - 39 - 16 - 1
    },
  },

  methods: {
    get_fields: function (code, content_type) {
      // if (this.data.length > 0) {
      //   let keys = _.keys(this.data[0]);
      //   let fields = _.map(keys, function (k) {
      //     return { key: k, label: k, thStyle: { width: "auto" } };
      //   });

      //   this.$tools.add_selectable_field(fields);
      //   fields.push("show_details");
      //   return fields;
      // }
      // return [];

      let this_ = this
      let endpoint_fields = TestHelper.get_table_fields(this_, code, content_type)

      endpoint_fields.fields = [
        { key: "num", label: "so.num", type: "string", sortable: true },
        {
          key: "customer_name",
          label: "so.customer_name",
          type: "string",
          sortable: true,
        },
        {
          key: "customer_code",
          label: "so.customer_code",
          type: "string",
          sortable: true,
        },
        {
          key: "sales_order_type_name",
          label: "so.sales_order_type_name",
          type: "string",
          sortable: true,
        },
        {
          key: "payment_type_name",
          label: "so.payment_type_name",
          type: "string",
          sortable: true,
        },
        {
          key: "valid_date",
          label: "so.valid_date",
          type: "string",
          sortable: true,
        },
        {
          key: "create_at",
          label: "so.create_at",
          type: "string",
          sortable: true,
        },
      ]

      // let fields=endpoint_fields.fields
      endpoint_fields.add_field({
        key: "button_column",
        type: "button",
        label: "del",
        button: {
          class: "cell_button",
          label: "",
          icon_class: "fa fa-remove",
        },
      })

      endpoint_fields.add_last_blank_field()

      return endpoint_fields.fields
    },

    active_tab(new_index) {
      this.tab_index = new_index
    },
    async add_orders(set_data) {
      let this_ = this
      // this_.$store.commit("add_biz_data", {
      //   content_type: "orders",
      //   content_path: "",
      //   data: { echo: "a", name: "myname", n: 1, time: Date.now() },
      // });
      // this_.data.push({
      //   echo: "",
      //   name: "sdf<h1>kasdfd啊可是对方</h1>dskf ",
      //   xxx_id: 2,
      //   age: 123456,
      //   n: 12.3456789,
      //   text: Date.now(),
      //   extra: [],
      //   _options_source_a: [{ value: 1, label: "1" }],
      // });

      // let endpoint = TestHelper.get_endpoint("data/s/atest");
      // // entryPoint.path=this_.$root.base_url+entryPoint.path
      // console.log(endpoint);

      // let r = await api.query_async(endpoint);
      // console.log(r);
      // this_.data.push(r[0].result.data[0]);

      // this_.$refs.TestTable.SetData(this_.data);
      // this_.$refs.TestTable.InsertItems(r[0].result.data);

      ///test

      let table_data = {}

      let a = []
      for (let i = 0; i < 3000; i++) {
        let c = _.clone(table_data)
        c.num = i + 1
        c.customer_name = "abc_" + (i + 1)
        c.customer_code = "abc_" + _.random(0, 10000)
        c.sales_order_type_name = "普通订单"
        c.payment_type_name = ""
        c.valid_date = this.getTime()
        c.create_at = this.getTime()
        a.push(c)
      }
      set_data(a)
      // this_.$refs.TestTable.AppendItems(a);

      // console.log(table_data);

      // _.each(this_.data, function(d) {
      //   Vue.set(d, "_cellVariants", { n: "info" });
      // });

      // console.log(this);

      // TestHelper.init_biz_data(this_, {
      //   content_path: "biz_data",
      //   content_type: "test_data_list",
      //   data: TestHelper.extract_list(r)
      // });
      // console.log("data is :");
      // console.log(this_.biz_data);
      // this_.$refs.TestTableExt.SetData(this_.biz_data.test_data_list);
    },
    getTime() {
      var _this = this
      let yy = new Date().getFullYear()
      var mm =
        new Date().getMonth() < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1
      var dd =
        new Date().getDate() < 10 ? "0" + new Date().getDate() : new Date().getDate()
      let hh = new Date().getHours()
      let mf =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes()
      let ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds()
      return yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss
    },
    async on_query(set_data) {
      let this_ = this
      this.add_orders(set_data)

      // this_.$event_bus.$on("error-401", function() {
      //   console.log("error-401");
      // });

      // let params = [
      //   // {
      //   //   content_type: "orders",
      //   //   code: "a",
      //   //   content_path: "https://api.cpsp.cc/" + "v2/data/s/atest",
      //   //   parameters: { c: "a" },
      //   //   ref: 111111,
      //   // },
      //   {
      //     url: "https://api.cpsp.cc/" + "v2/data/s/atest",
      //     parameters: { c: "b" }
      //   },
      //   {
      //     url: "https://api.cpsp.cc/" + "v2/data/s/atest",
      //     parameters: { c: "b" }
      //   },
      //   {
      //     url: "https://api.cpsp.cc/" + "v2/data/s/atest",
      //     parameters: { c: "b" }
      //   }
      //   // {
      //   //   content_type: "products",
      //   //   code: "c",
      //   //   content_path: "https://api.cpsp.cc/" + "v2/data/s/atest",
      //   //   parameters: { c: "c" + Date.now() },
      //   //   content_path: "cars",
      //   // },
      //   // {
      //   //   content_type: "data_type_a",
      //   //   code: "a",
      //   //   content_path: "https://api.cpsp.cc/" + "v2/data/s/atest",
      //   //   parameters: { c: "a" + Date.now() },
      //   // },
      // ];

      // let data = await api.query_async(params, function(result) {
      //

      //   if (result.code === "_index_1") {
      //     // return false;
      //   }
      //   if (
      //     result.content_type === "orders" ||
      //     result.content_type === "products"
      //   ) {
      //     this_.$store.commit("init_biz_data", {
      //       content_type: result.content_type,
      //       content_path: result.content_path,
      //       data: result.result.data
      //     });
      //   }

      //   return true;
      // });

      // console.log(data[2].result.data);
      // set_data(data[2].result.data);
    },
    on_change(data) {

      // let t = new Date().getTime();
      // if (data.field.key === "xxx_id") {
      //   data.item._options_source_a.push({ value: t, label: t + "" });
      // }
    },
    on_cell_button_click(data) {

      this.$refs.TestTable.RemoveItems(data.item)
    },
    on_input(data) {

    },
    state_change(data, cb) {

      // _.each(data.selected_items, function (o) {
      //   Vue.set(o, "_selected", false);
      // });
      if (data.selected_items && data.selected_items.length > 0) {
        this.msgModal("Are you sure that you want to " + data.state + "?").then(
          (value) => {
            if (value) {
              cb(true)
            }
          }
        )
      } else {
        this.msgToasts("Sorry, No Data !", "warning")
      }
    },
    tool_invoke(data) {

      // _.each(data.selected_items, function (o) {
      //   Vue.set(o, "_selected", false);
      // });
    },
    current_changed(old, current) {
      console.log("current_changed")
      console.log(old)

    },
  },
}
</script>

<style scoped>
.one_table>>>.hb_table_query_container_one_table {
  background-color: white;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_thead>.hb_thead_tr>.b-table-sticky-column.hb_thead_th_name {
  left: 21px;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_tbody>.hb_tbody_tr>.b-table-sticky-column.hb_tbody_td_name {
  left: 21px;
}
</style>
